import { Controller } from 'lib_ts/enums/routing/controllers';
import { FeatureFlagsRoutes } from 'lib_ts/enums/routing/routes/feature-flags';
import { IFeatureFlagEvaluationMap } from 'lib_ts/interfaces/feature-flags/i-feature-flag';
import { BaseRESTService } from 'services/_base-rest.service';

/**
 * Reads the server-evaluated { name: boolean } flag map for the current user.
 * Evaluation is server-side, so targeting rules never reach the client.
 */
export class FeatureFlagsService extends BaseRESTService {
  private static instance: FeatureFlagsService;
  static getInstance(): FeatureFlagsService {
    if (!FeatureFlagsService.instance) {
      FeatureFlagsService.instance = new FeatureFlagsService();
    }

    return FeatureFlagsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.FeatureFlags,
    });
  }

  /** fail closed: any error resolves to an empty map (nothing enabled) */
  async evaluate(): Promise<IFeatureFlagEvaluationMap> {
    return await this.get({
      uri: FeatureFlagsRoutes.Evaluate,
    })
      .then((result) => (result as IFeatureFlagEvaluationMap) ?? {})
      .catch(() => ({}));
  }
}
